import React from 'react';
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index.js'),
  loading: (props) => <h2>loading page...</h2>,
});



// WEBPACK FOOTER //
// ./src/containers/dashboard/loadable.js